module.exports.isOnBoardTemplate = ->
  @model.isOnBoardTemplate()
